import React, { Component } from "react";
import { Link } from "react-router-dom";
import { config } from "../config";
import i18n from "i18next";
import { withTranslation } from "react-i18next";
import defImage from "../images/not-image.png";

class ProductsRelatedList extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { t } = this.props;
    return (
      <div>
        <h4 className={"product-relative__title uk-text-bold"}>
          {t("item.relatedProducts")}
        </h4>
        <div >
          <div
            className={"uk-position-relative uk-visible-toggle "}
            tabIndex="-1"
            uk-slider={""}
          >
            <ul
              className={
                "uk-slider-items uk-child-width-1-2@s uk-child-width-1-3@m uk-grid-small  uk-grid"
              }
            >
              {Object.keys(this.props.products).map((itrp) => (
                <li key={itrp}>
                  <div className={"product-card uk-card uk-card-small"}>
                    <div
                      className={
                        "uk-card-media-top uk-text-center uk-padding-small"
                      }
                    >
                      <Link
                        to={{
                          pathname:
                            `/products/${
                              i18n.language +
                              "/" +
                              this.props.products[itrp].alias
                            }` +
                            "/item/" +
                            this.props.products[itrp].id,
                        }}
                      >
                        <img
                          className={
                            "product-card__image uk-height-small "
                          }
                          src={
                            this.props.products[itrp].mainImage
                              ? config.assetsPrfix +
                                "img/products/" +
                                this.props.products[itrp].mainImage
                              : defImage
                          }
                          alt={this.props.products[itrp].name}
                        />
                      </Link>
                    </div>
                    <div className={"uk-card-body"}>
                      <div className={"uk-text-center"}>
                        <Link
                          className={" product-card__name"}
                          title={this.props.products[itrp].name}
                          to={
                            `/products/${
                              i18n.language +
                              "/" +
                              this.props.products[itrp].alias
                            }` +
                            "/item/" +
                            this.props.products[itrp].id
                          }
                        >
                          <h3>{this.props.products[itrp].name}</h3>
                          
                        </Link>

                        <div className={"product-card__price uk-flex uk-flex-between uk-flex-left@m"}>
                          <span>
                            {this.props.products[itrp].price1 == 0.01 ? t('item.priceSpecify') : `${this.props.products[itrp].price1} грн.`}
                          </span>
                          {this.props.products[itrp].price2 > 0 ? (<span className="product-card__price-discount">
                            {this.props.products[itrp].price2 }
                          </span>): ''}
                          
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        "uk-card-footer"
                      }
                    >
                      <div className={" uk-width-1-1 uk-text-center"}>
                        <Link
                        className={"product-card__addtocart-btn uk-width-1-2 uk-display-inline-block"}
                          to={
                            `/products/${
                              i18n.language +
                              "/" +
                              this.props.products[itrp].alias
                            }` +
                            "/item/" +
                            this.props.products[itrp].id
                          }
                        >
                        {t("item.add_tocart")}
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            <a
              className="uk-position-center-left uk-position-small "
              href={"#"}
              uk-slidenav-previous={""}
              uk-slider-item="previous"
            ></a>
            <a
              className="uk-position-center-right uk-position-small "
              href={"#"}
              uk-slidenav-next={""}
              uk-slider-item="next"
            ></a>
          </div>
        </div>
      </div>
    );
  }
}
const ProductsRelated = withTranslation("translations")(ProductsRelatedList);
export default ProductsRelated;
